import React, { useContext } from 'react'
// libs
import { ThemeProvider } from '@mui/material'
// components
import AuthorizationWarning from 'components/UI/Warnings/AuthorizationWarning'
import { DrawerModal } from 'components/UI'
// hooks
import { useModalData, usePlanAccess } from 'hooks/index'
// constants
import { Modals } from 'constants/modals'
// containers
import MinimizedObjectivesListContainer from 'containers/MinimizedObjectivesList'
// utils
import { get } from 'lodash'
// context
import { LinkingModeContext } from 'containers/Plan/Edit/layers/API/Linking'
// views
import { Description, Header, PlanTitle, Wrapper } from './views'

const PAPER_PROPS = {
  style: {
    overflow: 'hidden'
  }
}

const PlanObjectivesListModal: React.FC = () => {
  const {
    hideModal,
    modalData: { currentPlan, isOpen, isSubPlan, parentPlan }
  } = useModalData({ modalType: Modals.PLAN_OBJECTIVES_LIST_MODAL })

  const { isLinkingMode } = useContext(LinkingModeContext)

  const shouldShowPlan = usePlanAccess(currentPlan)

  const clearUrlFromUselessQueries = () => {
    const keepParams = ['parentId', 'planViewMode']

    const params = new URLSearchParams(window.location.search)

    Array.from(params.keys()).forEach((key) => {
      if (!keepParams.includes(key)) {
        params.delete(key)
      }
    })

    const search = params.toString()
    const nextUrl = window.location.pathname + (search ? `?${search}` : '')

    window.history.replaceState(window.history.state, '', nextUrl)
  }

  const handleClose = () => {
    hideModal()
    clearUrlFromUselessQueries()
  }

  const theme = {
    components: {
      MuiDrawer: { styleOverrides: { modal: { display: isLinkingMode ? 'none' : 'initial' } } }
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <DrawerModal
        isOpen={isOpen}
        width={'50vw'}
        hideModal={hideModal}
        PaperProps={PAPER_PROPS}
        ModalProps={{ hideBackdrop: isLinkingMode }}>
        <Header handleClearClick={handleClose}>
          <PlanTitle>{get(currentPlan, 'name')}</PlanTitle>
        </Header>
        <Description>{`Select items from the plan "${get(currentPlan, 'name')}" that you wish to ${
          parentPlan ? ' link with items from  the' : 'add into the'
        }  "${get(parentPlan, 'name')}" plan`}</Description>

        {shouldShowPlan ? (
          <Wrapper>
            <MinimizedObjectivesListContainer
              currentPlan={currentPlan}
              parentPlan={parentPlan}
              isObjectivesModal
              isSubPlan={isSubPlan}
            />
          </Wrapper>
        ) : (
          <AuthorizationWarning />
        )}
      </DrawerModal>
    </ThemeProvider>
  )
}

export default PlanObjectivesListModal
